const charCodeOfA = 'A'.charCodeAt(0);
const alphabetLength = 'Z'.charCodeAt(0) - charCodeOfA + 1;
export class SpreadSheetPreviewHelper {
    static getColumnNameFromColumnNumber(columnNumber: number): string {
        // To store result (Excel column name)
        let columnName: string[] = [];

        while (columnNumber > 0) {
            // Find remainder
            const charIndex = columnNumber % alphabetLength;

            // If remainder is 0, then a
            // 'Z' must be there in output
            if (charIndex === 0) {
                columnName.push('Z');
                columnNumber = Math.floor(columnNumber / alphabetLength) - 1;
            } // If remainder is non-zero
            else {
                const charCode = charIndex + charCodeOfA - 1;
                const char = String.fromCharCode(charCode);
                columnName.push(char);
                columnNumber = Math.floor(columnNumber / alphabetLength);
            }
        }

        // Reverse the string
        return columnName.reverse().join('');
    }
}
